import { SendMessageIcon } from 'assets';
import { useFormContext } from 'react-hook-form-mui';
import { Button, Input } from 'view/components';
import * as S from './styled';

const SendMessageBlockFields = ({ onSubmit }) => {
  const { watch, reset, handleSubmit } = useFormContext<any>();

  return (
    <S.SendMessageBlock>
      <Input
        name="message"
        label=""
        placeholder="Write a message..."
        type="text"
        marginbottom={0.1}
      />
      <Button
        variant="contained"
        text=""
        type="submit"
        endIcon={<SendMessageIcon />} // isLoading ? <Spinner variant="contained" /> : <SendMessageIcon />
        style={{
          padding: '10px',
          width: '40px',
          minWidth: '40px',
          height: '40px',
          minHeight: '40px',
        }}
        disabled={!watch('message')}
        onClick={() => {
          handleSubmit(onSubmit)();
          /* onSubmit(); */
          reset();
        }}
      />
    </S.SendMessageBlock>
  );
};

export default SendMessageBlockFields;
